import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import PicturePhoto from '@material-ui/icons/InsertPhoto';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Dropzone from 'react-dropzone';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import PropTypes from 'prop-types';
import { useFormikContext, ErrorMessage } from 'formik';

const useStyles = makeStyles(theme => ({
  formContainer: {
    paddingLeft: '32px',
    paddingRight: '32px',
    paddingTop: '32px',
  },
  root: {
    border: `2px dashed ${theme.palette.primary.main}`,
    textAlign: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  icon: {
    fontSize: '72px',
  },
  logoButton: {
    marginBottom: '10px',
    paddingBottom: '0px',
    paddingTop: '0px',
  },
  logoButtonText: {
    color: '#1E678F',
    marginRigth: '12px',
  },
  deleteIcon: {
    marginLeft: '10px',
  },
}));

const AdminLogoUpload = props => {
  const { fileName, isEdit, updateFile } = props;
  const [fileValidation, setFileValidation] = useState<boolean>(false);
  const [fileError, setFileError] = useState<boolean>(false);
  const [handleDrop, setHandleDrop] = useState<boolean>(isEdit);
  const [imageName, setImageName] = useState<string>(fileName);
  const classes = useStyles();
  const { setFieldValue } = useFormikContext();

  const handleOnDrop = async files => {
    setFileError(false);
    setImageName(files[0].name);
    setFieldValue('file', true);
    updateFile(files);
    setHandleDrop(true);
  };

  const handleDropRejected = () => {
    setFileError(true);
  };

  const handleRemoveImage = () => {
    setFieldValue('file', false);
    setHandleDrop(false);
    setImageName('');
    updateFile(undefined);
  };

  useEffect(() => {
    setImageName(fileName);
  }, [fileName]);

  useEffect(() => {
    setHandleDrop(isEdit);
  }, [isEdit]);

  return (
    <Box className={classes.formContainer}>
      <Box style={{ color: 'red' }}>
        <ErrorMessage
          name="file"
          render={() => {
            setFileValidation(true);
            return 'A logo to upload is required';
          }}
        />
      </Box>
      {fileError && (
        <ul style={{ color: 'red' }}>
          <li>Accepted files: .jpg .png .jpeg</li>
          <li>Max files accepted: 1</li>
        </ul>
      )}
      {handleDrop && (
        <Button
          startIcon={<PicturePhoto />}
          endIcon={<DeleteIcon className={classes.deleteIcon} />}
          variant="outlined"
          size="large"
          className={classes.logoButton}
          onClick={handleRemoveImage}
        >
          <p className={classes.logoButtonText}>{imageName}</p>
        </Button>
      )}
      {!handleDrop && (
        <Card>
          <Box p={2}>
            <Dropzone
              onDropAccepted={files => handleOnDrop(files)}
              onDropRejected={files => handleDropRejected()}
              accept=".png, .jpg, .jpeg"
              maxFiles={1}
              multiple={false}
            >
              {({ getRootProps, getInputProps }) => {
                return (
                  <Box
                    p={2}
                    m={1}
                    className={classes.root}
                    {...getRootProps()}
                    style={{ borderColor: fileValidation ? 'red' : '#1E678F' }}
                  >
                    <input {...getInputProps()} multiple={false} />
                    <Box>
                      <CloudUploadIcon style={{ color: fileValidation ? 'red' : '#1E678F' }} className={classes.icon} />
                    </Box>
                    <Box>
                      <Typography variant="caption" style={{ color: fileValidation ? 'red' : '#1E678F' }}>
                        Drag and Drop your file here…
                      </Typography>
                    </Box>
                    <Typography variant="caption" style={{ color: fileValidation ? 'red' : '#1E678F' }}>
                      Or click here to select a file from your computer
                    </Typography>
                  </Box>
                );
              }}
            </Dropzone>
          </Box>
        </Card>
      )}
    </Box>
  );
};

AdminLogoUpload.propTypes = {
  fileName: PropTypes.string,
  isEdit: PropTypes.bool,
  updateFile: PropTypes.any, //Set file function
};

export default AdminLogoUpload;
